/* eslint-disable no-console */
/* eslint-disable react/no-unused-state */
import React, { Component } from 'react';
import AWS from 'aws-sdk';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Responsive, WidthProvider } from 'react-grid-layout';
import moment from 'utils/moment';
import styles from './homes.module.scss';
import Weather from './weather/Weathers';
import Advisories from './advisories/Advisories';
import { saveWeatherData } from '../../general_redux/actions';
import { fetchUserProfile } from '../../components/topbar/profile/redux/actions';
import { fetchPortalTilesList, clear, fetchPortalTilesAlingment } from './redux/actions';
import Loading from '../../components/loading';
import Report from './report/Reports';
import Feed from './socialFeed/Feeds';
import Events from './events/Events';
import PortalTile from './portalTile/PortalTile';
import Alert from './alert/Alert';
import ReportHazard from './reportHazard/ReportHazards';
import MaintenanceResponsibility from './MaintenanceResponsibility';
import DocumentList from '../Documents/DocumentList';
import { fetchDocuments, fetchDocumentsTypes } from '../Documents/redux/actions';

const ResponsiveGridLayout = WidthProvider(Responsive);

const Container = styled.div`
  max-width: 1640px;
  margin: 0 auto;
  padding: 0px 20px;
  background-color: rgb(250, 250, 282);
  border-radius: 0px;
`;
class Homes extends Component {
  constructor(props) {
    super(props);
    this.state = {
      tilesVisibilityStatus: {},
      newTiles: [],
      loadingStatus: false,
      events: [],
      initialRender: true,
      new_attachment_tiles: [],
      documentsList: [],
      defaultLayout: [
        { h: 4, i: 'a', w: 3, x: 0, y: 0 },
        { h: 4, i: 'b', w: 3, x: 0, y: 8 },
        { h: 4, i: 'c', w: 3, x: 8, y: 14 },
        { h: 10, i: 'd', w: 5, x: 0, y: 0 },
        { h: 4, i: 'e', w: 3, x: 8, y: 0 },
        { h: 4, i: 'f', w: 3, x: 8, y: 2 },
        { h: 4, i: 'g', w: 3, x: 8, y: 10 }
      ],
      init: true
    };
  }


  static getDerivedStateFromProps(props, state) {
    if (!Object.keys(state.tilesVisibilityStatus)?.length && props.portalTiles) {
      const newTiles = props.portalTiles.filter(tile => tile?.system_generated === false && tile?.visibility === true);
      const status = props.portalTiles.reduce(
        (obj, tile) => Object.assign(obj, { [tile?.tile_name]: tile?.visibility }), {}
      );

      return {
        ...state,
        tilesVisibilityStatus: status,
        newTiles
      };
    }
    if (state.newTiles.length > 0 && !state.events.length > 0 && state.initialRender) {
      const upcoming_events = [];
      const new_attachment_tiles = [];
      state.newTiles.forEach((tile) => {
        const obj = {};
        const events_happening = [];
        if (tile.events.length > 0) {
          tile.events.forEach((event) => {
            const currentDate = Date.now();
            const yesterday = moment(currentDate).add(-1, 'days').format('Y/M/D');
            const eventDate = moment(event.date).format('Y/M/D');
            if (moment(eventDate).isAfter(yesterday)) {
              events_happening.push(event);
            }
          });
          events_happening.sort((a, b) => new Date(a.date) - new Date(b.date));
          if (events_happening.length > 0) {
            obj.tile_name = tile.tile_name;
            obj.id = tile.id;
            obj.subscribed = tile.subscribed;
            obj.events = events_happening;
            obj.events_len = events_happening.length;
            upcoming_events.push(obj);
          }
        }
        if (tile.events.length === 0) {
          if (tile.attachment.length > 0 && tile.attachment[0].url) {
            new_attachment_tiles.push(tile);
          }
        }
      });
      return {
        ...state,
        initialRender: false,
        events: upcoming_events,
        new_attachment_tiles
      };
    }
    if (state.documentsList?.length !== props?.documentList?.documents?.length) {
      const filterRequired = props?.documentList?.documents?.filter(element => element.required);
      const filterRequiredDocs = filterRequired?.filter((doc) => {
        const hasDocumentType = !!doc?.document_type;
        const hasAttachments = doc?.attachments?.length > 0;
        const isValidDate = doc.valid_date && new Date(doc.valid_date).setHours(0, 0, 0, 0) >= new Date().setHours(0, 0, 0, 0);
        const hasStatus = doc?.status === 'reject';

        return !hasDocumentType || !hasAttachments || !isValidDate || hasStatus;
      }) || [];
      return {
        ...state,
        documentsList: filterRequiredDocs
      };
    }
    return {};
  }

  async componentDidMount() {
    const {
      actionFetchPortalTiles,
      actionFetchProfile,
      actionFetchPortalTilesAlingment,
      actionFetchDocuments,
      actionFetchDocumentsTypes
    } = this.props;
    actionFetchDocuments();
    actionFetchDocumentsTypes();
    actionFetchPortalTilesAlingment();
    // Initialize the Amazon Cognito credentials provider
    const gp = this.getAWSCredentails();
    gp.then(() => {
      this.setState({ loadingStatus: true });
      actionFetchPortalTiles();
      actionFetchProfile();
    }).catch((err) => {
      console.log(err);
    });
  }

  componentDidUpdate(prevProps) {
    const { actionClear, fetchPortalTileAction, layout } = this.props;
    const { init } = this.state;

    if (prevProps.fetchPortalTileAction.loading && !fetchPortalTileAction.loading) {
      // eslint-disable-next-line react/no-did-update-set-state
      this.setState({ loadingStatus: false }, actionClear);
    }

    if (prevProps.layout !== layout && init) {
      const newLayout = layout.map(tile => ({
        ...tile,
        isDraggable: false,
        isResizable: false
      }));

      if (!newLayout.some(tile => tile.i === 'a')) {
        newLayout.push({ h: 8, i: 'a', w: 3, x: 0, y: 0 });
      }

      // eslint-disable-next-line react/no-did-update-set-state
      this.setState({ defaultLayout: newLayout, init: false });
    }
  }


  getAWSCredentails = () => {
    AWS.config.region = process.env.REACT_APP_REGION;
    AWS.config.credentials = new AWS.CognitoIdentityCredentials({
      IdentityPoolId: process.env.REACT_APP_IDENTITY_POOL_ID
    });
    return AWS.config.credentials.getPromise();
  }

  updateDocuments = () => {
    const {
      actionFetchDocuments,
      actionFetchDocumentsTypes
    } = this.props;
    actionFetchDocuments();
    actionFetchDocumentsTypes();
  }

  render() {
    const { profile, layout, history } = this.props;
    const { tilesVisibilityStatus, events, loadingStatus, defaultLayout } = this.state;
    if (Object.keys(profile?.permissions).length === 1 && Object.keys(profile?.permissions)[0] === 'airfield_worker_driver_permit') {
      history.push('/adp/myapplications');
    }
    const renderTile = (key, condition, style = {}, datagrid, children) => {
      if (!condition) return null; // Return null if the condition is not met
      return (
        <div key={key} style={style} data-grid={defaultLayout?.find(i => i?.i === key) || datagrid}>
          {children}
        </div>
      );
    };
    const { documentsList, new_attachment_tiles } = this.state;
    const { documentTypes } = this.props;
    return (
      <div className={styles.home}>
        <Loading loadingStatus={loadingStatus} />
        {JSON?.stringify(layout) !== JSON?.stringify(undefined) && (
          <Container>
            <ResponsiveGridLayout
              layout={defaultLayout}
              breakpoints={{ lg: 1200, md: 996, sm: 768, xs: 480 }}
              cols={{ lg: 12, md: 8, sm: 4, xs: 2 }}
              rowHeight={90}
              width={1600}
              center
              allowOverlap={false}
              isResizable={false}
              isDraggable={false}
            >
              {/* Weather Tile */}
              {renderTile(
                'a',
                tilesVisibilityStatus?.Weather,
                { borderRadius: '5px' },
                { h: 8, i: 'a', w: 4, x: 3, y: 0 },
                <Weather />
              )}
              {renderTile(
                'b',
                tilesVisibilityStatus?.['Report Hazard'],
                {},
                { h: 4, i: 'b', w: 4, x: 0, y: 8 },
                <div className={styles.reportFeedContainer}>
                  <ReportHazard airport={profile.portal_airport} />
                </div>
              )}

              {/* Alerts Tile */}
              {renderTile(
                'c',
                tilesVisibilityStatus?.Alerts,
                {},
                { h: 4, i: 'c', w: 4, x: 8, y: 14 },
                <Alert />
              )}

              {/* Tenant Advisories Tile */}
              {renderTile(
                'd',
                tilesVisibilityStatus?.['Tenant Advisories'],
                {},
                { h: 10, i: 'd', w: 5, x: 0, y: 0 },
                <Advisories airport={profile?.portal_airport} />
              )}

              {/* Airfield Conditions Report Tile */}
              {renderTile(
                'e',
                tilesVisibilityStatus?.['Airfield Conditions Report'],
                {},
                { h: 4, i: 'e', w: 4, x: 8, y: 0 },
                <div className={styles.reportFeedContainer}>
                  <Report airport={profile?.portal_airport} />
                </div>
              )}

              {/* Social Media Tile */}
              {renderTile(
                'f',
                tilesVisibilityStatus?.['Social Media'] && profile?.urls,
                {},
                { h: 8, i: 'f', w: 4, x: 8, y: 2 },
                <Feed links={profile.urls} />
              )}

              {/* New Attachment Tiles */}
              {new_attachment_tiles?.map((tile, i) => {
                const L = layout?.find(t => t?.i === `${i}`) || { w: 8, h: 4, x: 0, y: 10 };
                return (
                  <div key={tile?.tile_name} data-grid={L}>
                    <PortalTile data={tile} />
                  </div>
                );
              })}

              {/* Events Tile */}
              {renderTile(
                'g',
                events?.length,
                {},
                { h: 4, i: 'g', w: 4, x: 0, y: 0 },
                <Events data={events} />
              )}
            </ResponsiveGridLayout>
        {profile?.maintenance_responsibility_enabled
          && <div style={profile?.current_tenant?.maintenance_responsibility
            ? { height: '250px', padding: '0 10px' } : { display: 'none' }}>
            <MaintenanceResponsibility maintenance_responsibility={profile?.current_tenant?.maintenance_responsibility} />
             </div>
        }
        {documentsList?.length > 0
          && <div className={styles.documentsTile}>
            <DocumentList homeTabTile documentsList={documentsList} document_types={documentTypes?.document_types || []}
              updateDocuments={this.updateDocuments} />
             </div>}
          </Container>

        )}
      </div>
    );
  }
}

Homes.propTypes = {
  intl: PropTypes.shape({}).isRequired
};

const mapStateToProps = state => ({
  currentModule: state.general.currentModule,
  weatherData: state.general.weather,
  documentList: state.document.documentList,
  profile: state.auth.profile,
  portalTiles: state.home.portalTilesList,
  fetchPortalTileAction: state.home.fetchPortalTileAction,
  layout: state.home.portalTilesAlingment?.portal_tiles_alignment?.map(tile => ({ ...tile, isDraggable: false })),
  documentTypes: state.document.documentTypes
});

const mapDispatchToProps = dispatch => ({
  actionSaveWeatherData: (weather) => {
    dispatch(saveWeatherData(weather));
  },
  actionFetchDocuments: () => {
    dispatch(fetchDocuments());
  },
  actionFetchDocumentsTypes: () => {
    dispatch(fetchDocumentsTypes());
  },
  actionFetchProfile: () => {
    dispatch(fetchUserProfile());
  },
  actionFetchPortalTiles: () => {
    dispatch(fetchPortalTilesList());
  },
  actionClear: () => {
    dispatch(clear());
  },
  actionFetchPortalTilesAlingment: () => {
    dispatch(fetchPortalTilesAlingment());
  }
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(injectIntl(Homes));
